<template>
    <div class="print-task-center">
        <div class="task-toolbar">
            <vxe-button :loading="loading" size="mini" status="primary" @click="loadList">查询</vxe-button>
        </div>
        <div class="task-table-wrap">
            <vxe-table :data="dataResult.results" :loading="loading" border height="100%">
                <!--            <vxe-column field="taskName" title="任务名称" min-width="220" show-overflow="tooltip"/>-->
                <vxe-column field="fileName" min-width="260" show-overflow="tooltip" title="文件名称"/>
                <!--            <vxe-column field="pageCount" title="页数" width="80" align="right"/>-->
                <vxe-column align="center" field="status" title="状态" width="100">
                    <template #default="{row}">
                        <span :class="statusClass(row.status)">{{ row.status }}</span>
                    </template>
                </vxe-column>
                <!--            <vxe-column field="creatorName" title="创建人" width="100"/>-->
                <vxe-column field="createTime" title="创建时间" width="165"/>
                <vxe-column field="finishTime" title="完成时间" width="165"/>
                <vxe-column align="center" title="操作" width="100">
                    <template #default="{row}">
                        <vxe-button
                            v-if="row.status === '成功'"
                            :loading="downloadingId === row.id"
                            status="primary"
                            mode="text"
                            @click="download(row)"
                        >下载
                        </vxe-button>
                        <span v-else-if="row.status === '失败'" :title="row.errorMessage" class="error-message">失败</span>
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
        <vxe-pager
            class="task-pager"
            v-model:current-page="page.page"
            v-model:page-size="page.pageSize"
            :layouts="['PrevPage', 'Number', 'NextPage', 'Sizes', 'Total']"
            :page-sizes="[10, 20, 50]"
            :total="dataResult.total"
            perfect
            @page-change="onPageChange"
        />
    </div>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import voucher from '@api/voucher';
import {message} from 'heyui.ext';

const loading = ref(false);
const downloadingId = ref(null);
const dataResult = ref({results: [], total: 0});
const page = ref({page: 1, pageSize: 10});
const downloadDebounceInterval = 1000;
let lastDownloadTime = 0;

const statusClass = status => ({
    'status-processing': status === '处理中',
    'status-success': status === '成功',
    'status-failed': status === '失败'
});

const loadList = () => {
    if (loading.value) {
        return;
    }
    loading.value = true;
    voucher.printTaskList(page.value).then(({data}) => {
        dataResult.value = data || {results: [], total: 0};
    }).finally(() => {
        loading.value = false;
    });
};

const download = row => {
    const now = Date.now();
    if (downloadingId.value || row.status !== '成功' || now - lastDownloadTime < downloadDebounceInterval) {
        return;
    }
    lastDownloadTime = now;
    downloadingId.value = row.id;
    voucher.printTaskDownload(row.id).then(({data}) => {
        if (!data?.url) {
            message.error('打印文件地址获取失败');
            return;
        }
        const link = document.createElement('a');
        link.href = data.url;
        link.download = row.fileName || '打印文件.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }).catch(() => {
        message.error('打印文件下载失败，请重试');
    }).finally(() => {
        downloadingId.value = null;
    });
};

const onPageChange = ({currentPage, pageSize}) => {
    page.value.page = currentPage;
    page.value.pageSize = pageSize;
    loadList();
};

onMounted(() => {
    loadList();
});
</script>

<style scoped>

.print-task-center {
    height: 100%;
    padding: 12px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.task-toolbar {
    flex: none;
    height: 36px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}

.task-table-wrap {
    min-height: 0;
    flex: 1;
    overflow: hidden;
}

.task-pager {
    flex: none;
}

.status-processing {
    color: #e6a23c;
}

.status-success {
    color: #0ca879;
}

.status-failed,
.error-message {
    color: #f56c6c;
}

</style>
